<template lang="pug">
form.billing.columns(@submit.prevent="")
  Loader(
    :loading="loading",
    :message="loaderMessage",
    :retry="loadeRetry",
    @load-retry="loadRetry"
  )

  .product.column.is-3(v-if="product")
    h2.title(v-if="!zone.preOrder") {{ zone.provider_name }}
    h2.title(v-else) {{ zone.provider_name + " Pre-Order" }}
    p {{ product.name }}
    hr
    ul.product-details-perks.is-size-6.has-text-left(v-if="productDetails")
      li.product-details-perk(v-for="pD in productDetails")
        fa-icon(icon="check-circle", style="margin-right: 5px")
        | {{ pD }}
    p.has-text-weight-normal.has-text-left(v-else) No details available for this product

  .details.column.box
    h2.title.has-text-left Details:

    .notification.is-danger(v-if="orderResponse")
      button.delete(@click.prevent="orderResponse = null")
      ul(v-if="orderResponse.errors")
        li
          h3.title(style="color: white !important")
            strong Errors
        li.has-text-left(v-for="(error, key) in orderResponse.errors")
          p.has-text-weight-normal
            strong.has-text-weight-bold {{ key }}:
            | {{ error }}
      p(v-else-if="orderResponse.message") {{ orderResponse.message }}
      p(v-else-if="typeof orderResponse == 'string'") {{ orderResponse }}
    .details-customer
      .input-group.has-text-left
        b Cell Number used for WhatsApp
        span.send__wrapper
          div.custom-phone
            VueTelInput.detail-custom-phone-input(
                :disabled="disabled.cellphone"
                v-model="customer.cellphone"
                :defaultCountry="phoneOptions.defaultCountry"
                :inputOptions="phoneOptions"
                :autoFormat="false"
                @input="cellphoneValidate"
                :preferredCountries="phoneOptions.preferredCountries"
                mode="international"
                ref="cellphoneInput"
                :dropdownOptions="{showDialCodeInSelection: true, showFlags: true, showDialCodeInList: true, disabled: true}"
              )
          .send__icon(v-if="show.throbberCellPhone")
            include ../assets/throbber.svg
        p.help.is-danger(v-if="cellphoneError") {{ cellphoneError }}
        p.create-contact-message(v-if="show.createContactMessage") You have been granted access with the right to create a {{authType[mesAuthAndAddMasterAccount] ? 'MASTER' : 'SUB'}} ACCOUNT CONTACT. Please fill in the details
        .input-group.has-text-left(v-if="show.billingCode")
          b Billing Code
          span.send__wrapper
            CustomInput(
              v-model="billingCode",
              :disabled="disabled.billingCode"
              required,
              placeholder="Billing Code (reference on your invoice)"
            )
            .send__icon(v-if="show.throbberBillingCode")
              include ../assets/throbber.svg
          p.help.is-danger(v-if="firstNameError") {{ firstNameError }}
          div.buttons-wrapper(v-if="show.checkBillingCode")
            button.button.is-primary.is-uppercase(
              type="button"
              @click="billingCodeValidate()"
            ) Continue
      br(v-if="subAccountAddText")
      span.sub-account-addiction(v-if="subAccountAddText") {{ subAccountAddText }}
      .input-group.has-text-left(v-if="show.accountsList")
        b Choose account
        v-select(:options="accountsList", :clearable="false", :disabled="disabled.accountsList" @input="accountListSelected()"
          :searchable="false" v-model="userAccount", placeholder="Select Account")
      .input-group.has-text-left(v-if="show.secretCode")
        b Secret Code
        span.send__wrapper
          CustomInput(
            v-model="secretCode",
            :disabled="disabled.secretCode",
            required,
            maxLength="6"
            placeholder="Your secret code is a 6 digit code sent to account holder cell"
          )
          .send__icon(v-if="show.throbberSecretCode")
            include ../assets/throbber.svg
      div.masked-block(v-if="show.maskedInformation")
          span.masked-block__title Secret code was sent to cell phone ending with {{primaryMaskedCellphone}} and email address starting with {{primaryMaskedEmail}}
      div.mes
        span.mes__interval(v-if="show.sendingInterval") {{sendingIntervalCount}} before we can re-send pin
        span.mes__billingCodePin(v-if="show.billingCodePinMessage") We sent PIN to the primary account/ Please ask them for a PIN
      p.help.is-danger(v-if="secretCodeError") {{ secretCodeError }}
      p.help.is-danger(v-if="sendButtonsError") {{ sendButtonsError }}
      .input-group.has-text-left(v-if="show.viaButtons")
        div.buttons-wrapper.via
          button.button.is-primary.is-uppercase(
            :disabled="disabled.WhatsAppButton"
            type="button"
            @click="getSecretCode(pinDeliveryChannel['WhatsApp'])"
          ) get pin via WhatsApp
          button.button.is-primary.is-uppercase(
          :disabled="disabled.TGButton"
          type="button"
            @click="getSecretCode(pinDeliveryChannel['TG'])"
        ) get pin via Telegram
          button.button.is-primary.is-uppercase(
          :disabled="disabled.SMSButton"
          type="button"
            @click="getSecretCode(pinDeliveryChannel['SMS'])"
        ) get pin via SMS
      div.input-group.other-inputs(v-if="show.dataInput")
        div.passport-block(v-show="!authType[mesAuthAndAddMasterAccount] && !authType[mesAuthAndAddSubAccount]")
          .input-group.has-text-left
            b ID/Passport/Company Registration Number
            CustomInput(
              v-model="customer.idNumber",
              required,
              placeholder="ID/Passport/Company Registration Number"
            )
            p.help.is-danger(v-if="idNumberError") {{ idNumberError }}
            div(v-if="customer.idNumber.indexOf('/') >= 0")
              .input-group.has-text-left
                b Company Name
                CustomInput(
                  v-model="customer.companyName",
                  required,
                  placeholder="Company Name"
                )
                p.help.is-danger(v-if="companyNameError") {{ companyNameError }}
              .input-group.has-text-left
                b VAT Number
                CustomInput(
                  v-model="customer.vatNumber",
                  required,
                  placeholder="VAT Number"
                )
              p.help.is-danger(v-if="vatNumberError") {{ vatNumberError }}
        .input-group.has-text-left
          b Title
          v-select(:options="titleIds", :reduce="data => data.value.toString()", :clearable="false",
            :searchable="false" v-model="customer.titleId", placeholder="Select Title", @input="printTitle")
          p.help.is-danger(v-if="titleIdError") {{ titleIdError }}
        .input-group.has-text-left
          b First Name
          CustomInput(
            v-model="customer.firstName",
            required,
            placeholder="First Name"
          )
          p.help.is-danger(v-if="firstNameError") {{ firstNameError }}
        .input-group.has-text-left
          b Last Name
          CustomInput(
            v-model="customer.lastName",
            required,
            placeholder="Last Name"
          )
          p.help.is-danger(v-if="lastNameError") {{ lastNameError }}
        .input-group.has-text-left
          b Email Address
          CustomInput(
            v-model="customer.email",
            required,
            placeholder="Email Address"
          )
          p.help.is-danger(v-if="emailError") {{ emailError }}
        div.input-group.other-inputs(v-if="show.dataInput && (!authType[mesAuthAndAddMasterAccount] && !authType[mesAuthAndAddSubAccount])")
          .input-group.has-text-left
            b Daytime Contact Number
            CustomInput(
              v-model="customer.daytimeContactNumber",
              required,
              placeholder="Daytime Contact Number"
            )
            p.help.is-danger(v-if="daytimeContactNumberError") {{ daytimeContactNumberError }}

  .finalized.box.column.is-3(v-if="product")
    hr.is-block-tablet.is-hidden-desktop
    .finalized-address.has-text-weight-bold
      | {{ builtAddress }}
    a(
      @click="$router.push({ name: 'home' })",
      style="color: #000; text-decoration: underline"
    ) Change address
    h1.title(style="margin-top: 2rem") R{{ product.monthly }}
    p.subtitle.finalized-tax Price per month
    div.right-info-block(v-show="installType !== 'upgrade'")
      p.is-size-7(v-if="product.setup == '0.00'") FREE
        span  Activation
      p.is-size-7(v-else) R{{ product.setup }} INCL. VAT
        span.has-text-weight-normal  Once off setup fee
    br
    div(v-show="show.submitButtonAndCheckBoxConditions")
      p.is-size-7 You only pay once you're connected
      .tandcs.is-size-7
        label.checkbox
          input(type="checkbox", name="tandcs", :value="true", v-model="tandcs")
          span(v-html="termsString").has-text-weight-normal
        p.has-text-left.has-text-danger.has-text-weight-normal(
          v-if="tandcsError"
        ) {{ tandcsError }}
      button.button.is-primary.is-uppercase.finalize-button(
        @click="checkForm",
        :disabled="disabled.confirmButton"
        :type="showCustomerDetails ? 'button' : 'submit'"
      )
        span(v-if="installType === 'upgrade' || !accountsList.length")
          | CONFIRM AND CONTINUE
        span(v-else-if="installType !== 'upgrade' && accountsList.length")
          | Order Now
</template>

<script>
import axios from "axios";
import CustomInput from "@/components/CustomInput.vue";
import {VueTelInput} from "vue-tel-input";
import 'vue-tel-input/dist/vue-tel-input.css';
import store from "@/store";
import _ from "lodash";
import moment from "moment";
import Loader from "@/components/Loader.vue";
import brand from "@/brand";


export default {
  name: "Purchase",
  components: {
    Loader,
    CustomInput,
    VueTelInput,
  },
  data() {
    return {
      mesAuthThis: "authorize this",
      mesAuthAndAddMasterAccount: "authorize and add as a masteaccount contact",
      mesAuthAndAddSubAccount: "authorize and add as a sub-account contact",
      phoneOptions: {
        placeholder: "Cellphone Number",
        defaultCountry: "ZA",
        preferredCountries: [
          "ZA",
          "RU",
          "GB"
        ],
        required: true,
        validCharactersOnly: true,
        maxlength: 13,
        mask: {},
      },
      sendingIntervalCount: 60,
      loading: false,
      loaderMessage: null,
      loadeRetry: false,
      activate_cost: "",
      debounce : null,

      /* eslint-disable */
      numRegex: /^\d+$/,
      emailRegex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      compRegex: /^((19|20)[\d]{2}\/[\d]{6}\/[\d]{2})$/,
      passportRegex: /^(?!^0+$)[a-zA-Z0-9]{3,20}$/,
      firstLastNameRegex: /^[a-zA-Z' \-]+$/,
      /* eslint-enable */

      errors: [],
      customer: this.$store.getters.getCustomer,
      showCustomerDetails: true,
      secretCodeError: "",
      sendButtonsError: "",
      titleIdError: "",
      firstNameError: "",
      lastNameError: "",
      emailError: "",
      daytimeContactNumberError: "",
      cellphoneError: "",
      idNumberError: "",
      companyNameError: "",
      vatNumberError: "",
      streetAddressError: "",
      suburbError: "",
      provinceError: "",
      postalCodeError: "",
      tandcs: false,
      tandcsError: "",
      orderResponse: null,
      sendInt: null,
      sendCount: 0,
      accountsList: [],
      userAccount: [],
      accountStatusesInSelect: {
        "Active Account": "Active",
        "Suspended Account": "Suspended",
        "Inactive Account": "Inactive"
      },
      subAccountAddText: "",
      phoneValidate: "",
      billingCode: null,
      secretCode: "",
      show: {
        submitButtonAndCheckBoxConditions: false,
        secretCode: false,
        dataInput: false,
        viaButtons: false,
        throbberSecretCode: false,
        throbberCellPhone: false,
        throbberBillingCode: false,
        sendingInterval: false,
        accountsList: false,
        billingCode: false,
        checkBillingCode: true,
        billingCodePinMessage: false,
        createContactMessage: false,
        maskedInformation: false
      },
      disabled: {
        SMSButton: false,
        TGButton: false,
        WhatsAppButton: false,
        cellphone: false,
        confirmButton: true,
        secretCode: false,
        accountsList: false,
        billingCode: false
      },
      addressCode: store.state.addressCode
        ? store.state.addressCode
        : undefined,
      addressId: store.state.addressId ? store.state.addressId : undefined,
      product: store.state.product ? store.state.product : undefined,
      productIds: store.state.productIds ? store.state.productIds : {},
      pinDeliveryChannel: {
        WhatsApp: "WhatsApp",
        TG: "TG",
        SMS: "SMS"
      },
      authType: {
        "authorize this": false,
        "authorize and add as a masteaccount contact": false,
        "authorize and add as a sub-account contact": false
      },
      primaryMaskedCellphone: "",
      primaryMaskedEmail: ""
    };
  },
  mounted() {
    if (this.product === undefined) {
      this.$router.push({ name: "home" });
    }

    this.getUpdatedProductDetails();
  },
  watch: {
    "secretCode": {
      async handler(code) {
        if(code) {
          if(this.show.secretCode && code.length === 6) {
            this.show.throbberSecretCode = true;
            this.secretCodeError = "";
            this.disabled.TGButton = true;
            this.disabled.SMSButton = true;
            this.disabled.WhatsAppButton = true;
            let requestData = {
              phoneNumber: this.phoneValidate,
              inputCode: code
            };
            console.log("TEST DATA BILLING CODE VIEW", this.billingCode);
            if (this.billingCode) {
              requestData.billingCode = this.billingCode;
            }
            try {
              const response = await axios.post(`${process.env.VUE_APP_AUTHSERVICE_URL}secretCodeValidate`, requestData);
              if (response.data.type) {
                this.authType[response.data.type] = true;
              }
              if(response.data.valid) {
                let userCookie = response.data.cookie;
                try {
                  this.show.submitButtonAndCheckBoxConditions = true;
                  if(!this.billingCode) {
                    const response = await axios.post(`${process.env.VUE_APP_BACKEND_URL}order/find_accounts`, {
                      cellphoneNumber: this.phoneValidate,
                      cookie: userCookie,
                      brand: brand.getBrand()
                    })
                    if (!response.data.cookieError) {
                      this.serializeAccountSelect(response.data);
                    } else {
                      this.clearingFields();
                    }
                  } else {
                    if(!this.authType[this.mesAuthThis]) {
                      this.show.dataInput = true;
                      this.show.billingCode = false;
                      this.show.createContactMessage = true;
                      this.show.maskedInformation = false;
                      this.disabled.confirmButton = false;
                    } else {
                      const response = await axios.post(`${process.env.VUE_APP_BACKEND_URL}order/find_account_by_billing_code`, {
                        cellphoneNumber: this.phoneValidate,
                        billingCode: this.billingCode,
                        cookie: userCookie
                      })
                      if (!response.data.cookieError) {
                        this.serializeAccountSelect(response.data);
                      } else {
                        this.clearingFields();
                      }
                    }
                  }
                } catch (error) {
                  if (typeof error.response.data == "string") {
                    this.orderResponse = error.response.data;
                  } else if (error.response.data.length > 0) {
                    this.orderResponse = error.response.data[0];
                  } else if (Object.keys(error.response.data).length === 0) {
                    this.orderResponse = "Server error. Please try another time...";
                  } else {
                    this.orderResponse = error.response.data;
                  }
                  this.show.throbberSecretCode = false;
                  return;
                }
                if(this.secretCodeError) {
                  this.secretCodeError = "";
                }
                this.show.secretCode = false;
                this.show.viaButtons = false;
                this.show.sendingInterval = false;
              } else {
                this.show.throbberSecretCode = false;
                if(response.data.tryCount) {
                  this.secretCodeError = "Incorrect PIN. Please try again.";
                  this.secretCode = "";
                }
                if(response.data.expired) {
                  this.secretCodeError = "PIN has expired. Please try again.";
                  this.secretCode = "";
                }
                console.log("TEST DATA VALIDATE PIN", response.data);
                if(!response.data.valid && !response.data.tryCount && !response.data.expired) {
                  this.secretCodeError = "You have exceeded authorization attempts.";
                  this.secretCode = "";
                  this.disabled.secretCode = true;
                  this.show.sendingInterval = false;
                  clearInterval(this.sendInt);
                  this.sendingIntervalCount = 60;
                  this.disabled.TGButton = false;
                  this.disabled.SMSButton = false;
                  this.disabled.WhatsAppButton = false;
                  this.sendCount = 0;
                }
                code = "";
              }
            } catch (error) {
              this.clearingFields();
            }

          }
        }
      }
    },
    customer: {
      handler(val) {
        this.$store.commit("setCustomer", val);
      },
      deep: true,
    },
    "customer.cellphone": {
      handler(val) {
        if (
          !this.customer.daytimeContactNumber.length ||
          val.indexOf(this.customer.daytimeContactNumber) >= 0
        ) {
          this.customer.daytimeContactNumber = val;
        }
        //this.$refs.cellphoneInput.choose(this.phoneOptions.defaultCountry, true);
      },
      deep: true,
    },
  },
  computed: {
    titleIds() {
      return this.$store.getters.getTitleIds;
    },
    promoCodeId() {
      return this.$store.getters.getPromoCodeId;
    },
    installType() {
      return this.$store.getters.getInstallType;
    },
    banks() {
      return this.$store.getters.getBanks;
    },
    builtAddress() {
      return this.$store.getters.getBuiltAddress;
    },
    addresses() {
      return this.$store.getters.getAddressList;
    },
    unitNumber() {
      return this.$store.getters.getUnitNumber;
    },
    buildingName() {
      return this.$store.getters.getBuildingName;
    },
    fullAddress() {
      return this.$store.getters.getFullAddress;
    },
    zone() {
      return this.$store.getters.getZone;
    },
    provinces() {
      return this.$store.getters.getProvinces;
    },
    position() {
      return this.$store.getters.getPosition;
    },
    productDetails() {
      if (this.product && this.product.details.length) {
        return this.product.details.split(/\r?\n/g);
      }
      return null;
    },
    termsString() {
      const termsStrings = {"cybersmart": "I have read, understood and accept Cybersmart <a href=\"/assets/terms.pdf\" target=\"_blank\">Terms and Conditions</a>.",
        "ftta": "I have read, understood and accept FTTA <a href=\"/assets/terms_ftta.pdf\" target=\"_blank\">Terms and Conditions</a>.",
        "gigalight": "I have read, understood and accept Gigalight <a href=\"/assets/terms_gigalight.pdf\" target=\"_blank\">Terms and Conditions</a>."
      };
      return termsStrings[brand.getBrand()];
    }
  },
  methods: {
    serializeAccountSelect(array) {
      this.accountsList = [];
      this.userAccount = [];
      const unique = Array.from(new Set(array.map(item => JSON.stringify(item)))).map(item => JSON.parse(item));
      unique.map((data) => {
        let accountStatus = this.getAccountStatus(data.accountStatus);
        this.accountsList.push({
          value: data.accountId,
          label: `${data.customerName} (${accountStatus}) | ${data.accountId}`
        })
      });
      this.show.throbberSecretCode = false;
      this.show.accountsList = true;
      if(unique.length === 1) {
        this.userAccount = this.accountsList[0];
        this.disabled.accountsList = true;
        this.disabled.confirmButton = false;
      }
    },
    accountListSelected() {
      this.disabled.confirmButton = false;
    },
    async billingCodeValidate() {
      this.show.throbberBillingCode = true;
      try {
        const response = await axios.post(  `${process.env.VUE_APP_BACKEND_URL}order/check_billing_code`, {
          billingCode: this.billingCode,
        })
        if (response.data.result) {
          this.getSecretCode(this.pinDeliveryChannel['SMS']);
          this.disabled.billingCode = true;
          this.show.checkBillingCode = false;
        } else {
          this.clearingFields();
        }
      } catch (error) {
        console.log(Object.keys(error.response.data).length);
        if (typeof error.response.data == "string") {
          this.orderResponse = error.response.data;
        } else if (error.response.data.length > 0) {
          this.orderResponse = error.response.data[0];
        } else if (Object.keys(error.response.data).length === 0) {
          this.orderResponse = "Server error. Please try another time...";
        } else {
          this.orderResponse = error.response.data;
        }
        this.show.throbberBillingCode = false;
      }
    },
    clearingFields() {
      if(!this.show.dataInput) {
        this.show.dataInput = true;
        this.show.billingCode = false;
        this.show.secretCode = false;
        this.disabled.cellphone = false;
        this.show.viaButtons = false;
        this.show.sendingInterval = false;
        this.show.accountsList = false;
        this.show.checkBillingCode = false;
        this.show.billingCodePinMessage = false;
        this.disabled.WhatsAppButton = false;
        this.disabled.TGButton = false;
        this.disabled.SMSButton = false;
        clearInterval(this.sendInt);
        this.sendingIntervalCount = 60;
        this.disabled.confirmButton = false;
        this.show.submitButtonAndCheckBoxConditions = true;
        this.show.maskedInformation = false;
      }
    },
    async cellphoneValidate(cellphone , obj) {
      this.phoneValidate = obj.number;
      if (this.show.dataInput) {
        this.show.dataInput = false;
      }
      if (this.show.viaButtons) {
        this.show.viaButtons = false;
      }
      if (this.show.billingCode) {
        this.show.billingCode = false;
      }
      if (obj.countryCode === "ZA") {
        if (obj.nationalNumber[0] !== "0") {
          this.phoneValidate = "0"+obj.nationalNumber;
        } else {
          this.phoneValidate = obj.nationalNumber;
        }
        obj.valid = this.phoneValidate.length === 10;
      }
      clearTimeout(this.debounce);
      if(obj.valid) {
        this.debounce = setTimeout(async () => {
          try {
            this.show.throbberCellPhone = true;
            this.disabled.cellphone = true;
            const response = await axios.post(  `${process.env.VUE_APP_BACKEND_URL}order/cell_exist`, {
              cellphoneNumber: this.phoneValidate,
              brand: brand.getBrand()
            })
            if(response.data.result) {
              this.disabled.cellphone = false;
              if(this.show.dataInput) {
                this.show.dataInput = false;
                this.disabled.confirmButton = true;
              }
              this.show.viaButtons = true;
              this.show.throbberCellPhone = false;

            }  else {
              this.disabled.cellphone = false;
              this.show.throbberCellPhone = false;
              if (this.installType === "upgrade") {
                this.show.billingCode = true;
              } else {
                this.clearingFields();
              }
            }
          } catch (error) {
            if (typeof error.response.data == "string") {
              this.orderResponse = error.response.data;
            } else if (error.response.data.length > 0) {
              this.orderResponse = error.response.data[0];
            } else if (Object.keys(error.response.data).length === 0) {
              this.orderResponse = "Server error. Please try another time...";
            } else {
              this.orderResponse = error.response.data;
            }
            this.show.throbberCellPhone = false;
          }
        }, 1001);
      }
    },
    async getSecretCode(pinDeliveryChannel) {
      this.secretCode = "";
      this.sendCount++;
      if(this.sendCount >= 3) {
        this.sendButtonsError = "Number of attempts exceeded. Re-send PIN not available";
      } else {
        this.secretCodeError = "";
        this.disabled.secretCode = false;
      }
      this.disabled.cellphone = true;
      this.disabled.WhatsAppButton = true;
      this.disabled.TGButton = true;
      this.disabled.SMSButton = true;

      if(this.secretCodeError) {
        this.secretCodeError = "";
      }
      let requestData = {
        phoneNumber: this.phoneValidate,
        pinDeliveryChannel: pinDeliveryChannel
      };
      if (this.billingCode) {
        requestData.billingCode = this.billingCode;
      } else {
        this.show.sendingInterval = true;
        this.show.secretCode = true;
      }
      try {
        const response = await axios.post( `${process.env.VUE_APP_AUTHSERVICE_URL}getSecretCode/`, requestData);
        if (response) {
          if (this.billingCode) {
            this.show.sendingInterval = true;
            this.show.secretCode = true;
            this.show.throbberBillingCode = false;
            this.primaryMaskedCellphone = response.data.primaryMaskedCellphone;
            this.primaryMaskedEmail = response.data.primaryMaskedEmail;
            this.show.maskedInformation = true;
          }
          this.sendInt =  setInterval(() => {
            if(this.sendingIntervalCount > 0) {
              this.sendingIntervalCount = this.sendingIntervalCount - 1;
            } else {
              this.show.sendingInterval = false;
              if(this.sendCount <= 3) {
                this.disabled.WhatsAppButton = false;
                this.disabled.TGButton = false;
                this.disabled.SMSButton = false;
              }
              clearInterval(this.sendInt);
              this.sendingIntervalCount = 60;
            }
          }, 1000);
        }
      } catch (error) {
        this.clearingFields();
      }
    },
    printTitle() {
      console.log("title: ", JSON.stringify(this.customer.titleId));
      //this.customer.titleId = event.target.value;
    },
    loadRetry() {},
    async getUpdatedProductDetails() {
      if (this.zone &&
        this.zone.provider_name != "Cybersmart" &&
        this.installType == "existing"
      ) {
        this.loading = true;

        try {
          const fD = new FormData();
          fD.set("promoCode", `${this.promoCodeId}-MIGRATION`);

          const response = await this.$http.post(
            `${process.env.VUE_APP_BACKEND_URL}feasibility/productdetails`,
            fD
          );
          console.log("product details response", response);

          if (response.data.products && response.data.products.length) {
            const tempProd = _.find(response.data.products, (p) => {
              return p.productid == this.product.productid;
            });
            if (tempProd) {
              this.product = tempProd;
              let productIds = {
                promocodeproductid: this.product.promocodeproductid,
                productid: this.product.productid,
                promocodeid: response.data.code
              };
              console.log("productIds old", this.productIds, ", new", productIds);
              this.productIds = productIds;
            }
          }
          this.loading = false;
        } catch (error) {
          console.log("product details error", error.response);
          this.loading = false;
        }
      }
    },
    makeUsername() {
      // Username = Street number + First 6 letters of the street address + unit number @ lightspeed.co.za
      // ( if this fails validation, append a - + today’s day at the end of the username, I.e 16kingsrd20-23@lightspeed.co.za
      /* eslint-disable */
      const adParts = this.builtAddress.split(",");
      let strAdParts, strNum, strAd, unit;
      const atDomains = {
        "cybersmart": "@lightspeed.co.za",
        "ftta":       "@fttafibre",
      };
      const atDomain = atDomains[brand.getBrand()] || "@lightspeed.co.za";

      if (adParts[0].indexOf("Unit") >= 0) {
        (strAdParts = adParts[1].split(" ")),
          (strNum = strAdParts.splice(0, 1)),
          (strAd = strAdParts.join("").substring(0, 6)),
          (unit = adParts[0].replace("Unit", "").trim());
      } else {
        (strAdParts = adParts[0].split(" ")),
          (strNum = strAdParts.splice(0, 1)),
          (strAd = strAdParts.join("").substring(0, 6)),
          (unit = "");
      }

      return `${strNum}${strAd}${unit}-${moment().format(
        "DD"
      )}${atDomain}`;
      /* eslint-enable */
    },
    areFieldsValid() {
      this.errors = [];

      if (this.show.dataInput) {
        if (!this.customer.titleId) {
        this.titleIdError = "Missing title.";
        this.errors.push("Missing title.");
        } else {
          this.titleIdError = "";
        }
        if (!this.customer.firstName) {
          this.firstNameError = "Missing first name.";
          this.errors.push("Missing first name.");
        } else if (!this.firstLastNameRegex.test(this.customer.firstName)) {
          this.firstNameError = "Letters, hyphen and apostrophe is allowed in first name.";
          this.errors.push("Letters, hyphen and apostrophe is allowed in first name.");
        } else {
          this.firstNameError = "";
        }
        if (!this.customer.lastName) {
          this.lastNameError = "Missing last name.";
          this.errors.push("Missing last name.");
        } else if (!this.firstLastNameRegex.test(this.customer.lastName)) {
          this.lastNameError = "Letters, hyphen and apostrophe is allowed in last name.";
          this.errors.push("Letters, hyphen and apostrophe is allowed in last name.");
        } else {
          this.lastNameError = "";
        }
        if (!this.customer.email) {
          this.emailError = "Missing email.";
          this.errors.push("Missing email.");
        } else if (!this.emailRegex.test(this.customer.email.trim())) {
          this.emailError = "Invalid email. (e.g. name@example.com)";
          this.errors.push("Invalid email. (e.g. name@example.com)");
        } else {
          this.emailError = "";
        }

        if (!this.authType[this.mesAuthAndAddMasterAccount] && !this.authType[this.mesAuthAndAddSubAccount]) {
          if (!this.customer.daytimeContactNumber.trim() && !this.show.dataInput) {
            this.daytimeContactNumberError = "Missing daytime contact number.";
            this.errors.push("Missing daytime contact number.");
          } else if (
              !this.numRegex.test(this.customer.daytimeContactNumber.trim()) ||
              this.customer.daytimeContactNumber.trim().length !== 10
          ) {
            this.daytimeContactNumberError =
                "Invalid daytime contact number. (e.g. 0761234765)";
            this.errors.push("Invalid daytime contact number. (e.g. 0761234765)");
          } else {
            this.daytimeContactNumberError = "";
          }
          /*if (!this.customer.cellphone.trim()) {
            this.cellphoneError = "Missing cellphone number.";
            this.errors.push("Missing cellphone number.");
          } else if (
            !this.numRegex.test(this.customer.cellphone.trim()) ||
            this.customer.cellphone.trim().length !== 10
          ) {
            this.cellphoneError = "Invalid cellphone number. (e.g. 0761234765)";
            this.errors.push("Invalid cellphone number. (e.g. 0761234765)");
          } else {
            this.cellphoneError = "";
          }*/

          if (!this.customer.idNumber) {
            this.idNumberError = "Missing ID / Passport / Company Registration.";
            this.errors.push("Missing ID / Passport / Company Registration.");
          } else {
            const isPassport = this.passportRegex.test(this.customer.idNumber);
            if (!isPassport) {
              if (!this.compRegex.test(this.customer.idNumber)) {
                this.idNumberError =
                    "Invalid ID / Passport / Company Registration. (e.g. 2001014800086 / 86YH34567 / 2001/014800/86)";
                this.errors.push(
                    "Invalid ID / Passport / Company Registration. (e.g. 2001014800086 / 86YH34567 / 2001/014800/86)");
              } else {
                this.idNumberError = "";

                if (!this.customer.companyName) {
                  this.companyNameError = "Missing company name.";
                  this.errors.push("Missing company name.");
                } else {
                  this.companyNameError = "";
                }
              }
            } else {
              this.idNumberError = "";
            }
          }
        }
        console.log(this.errors);
      }
      if (!this.tandcs) {
        this.tandcsError = "Please accept the terms and conditions.";
        this.errors.push("Please accept the terms and conditions.");
      } else {
        this.tandcsError = "";
      }

      return !this.errors.length;
    },
    async checkForm(e) {
      if (this.areFieldsValid()) {
        if (this.installType === "upgrade") {
          if (this.authType[this.mesAuthAndAddMasterAccount] || this.authType[this.mesAuthAndAddSubAccount]) {
            await this.createContact();
            await this.submitUpgradeDowngrade();
          } else {
            await this.submitUpgradeDowngrade();
          }
        } else {
         await this.submitOrder();
        }
      }

      e.preventDefault();
    },
    async createContact() {
      const userTitle = this.titleIds.find(item => item.value == this.customer.titleId);
      const contactType = this.authType[this.mesAuthAndAddMasterAccount] ? "General Contact" : "Sub Account Contact";
      this.loading = true;
      const tempBody = {
        masterAccountId: this.billingCode,
        title: userTitle.label,
        firstName: this.customer.firstName,
        lastName: this.customer.lastName,
        cellPhoneNumber: this.phoneValidate,
        workPhoneNumber: this.phoneValidate,
        emailAddress: this.customer.email.trim(),
        contactType: contactType,
        contactLevel: ""
      };

      try {
        const response = await axios.post(`${process.env.VUE_APP_BACKEND_URL}order/create_contact`, tempBody);

        if (response) {
          this.accountsList.push({
            value: this.billingCode,
            label: this.billingCode
          })
          this.userAccount = this.accountsList[0];
          console.log("ACCOUNT CREATED.......");
        }
      } catch (error) {
        this.loading = false;

        if(error.response) {
          if (typeof error.response.data == "string") {
            this.orderResponse = error.response.data;
          } else if (error.response.data.length > 0) {
            this.orderResponse = error.response.data[0];
          } else if (Object.keys(error.response.data).length === 0) {
            this.orderResponse = "Server error. Please try another time...";
          } else {
            this.orderResponse = error.response.data;
          }
        } else {
          this.orderResponse = "Server error. Please try again...";
        }
        return false;
      }
    },
    findSimilarAddress() {
      console.log("fullAddress: ", JSON.stringify(this.fullAddress));
      if (!this.addresses.length) {
        console.log("Empty zone addresses");
        return null;
      }

      let address = this.findAddressId(this.unitNumber, this.fullAddress.street_number,
      this.fullAddress.route, this.addresses);

      if (!address && this.fullAddress.routeShort) {
        address = this.findAddressId(this.unitNumber, this.fullAddress.street_number,
            this.fullAddress.routeShort, this.addresses);
      }

      return address;
    },
    findAddressId(unit, street_number, route, addressesToSearch) {
      if (!route) {
        return null;
      }
      const unitStr = unit? "Unit " + unit + ", " : "";
      const addressPart = this.prepareAddressForCompare(unitStr +`${street_number || ""} ${route}`.trim());
      const addressesToSearchPrepared = addressesToSearch.map(address => {
        return { displayAddress: this.prepareAddressForCompare(address.displayAddress),
          id: address.id
        }
      });

      console.log("Looking for ", addressPart);
      console.log("In ", JSON.stringify(addressesToSearchPrepared));

      const customerAddress = addressesToSearchPrepared.find(address => address.displayAddress.includes(addressPart));

      return customerAddress? customerAddress.id : null;
    },
    prepareAddressForCompare(address) {
      return address.toLowerCase().replace(/[,\s]/g, "");
    },
    async submitZone(userDetail) {
      // check for existing address / zone
      // _.find(this.addresses, (o) => {
      //   return o.displayAddress == this.builtAddress;
      // });

      const zone = {
        position: this.position,
        address: this.fullAddress,
        province: this.fullAddress.administrative_area_level_1,
        unit: this.unitNumber,
        provider_name: this.zone.provider_name,
        user: userDetail,
      };
      console.log("zone info", zone);

      try {
          const response = await this.$http.post(
          `${process.env.VUE_APP_BACKEND_URL}order/create_zone_record`,
          zone
        );
        console.log("zone response", response.data);

        if (response.data.status !== "Success") {
          console.log("zone create error", response.data);

          if (response.data.fakePass) {
            this.$router.push({
              name: "complete",
              params: {
                orderNumber: response.data.orderNumber,
              },
            });
          }

          return false;
        }

        this.addressCode = response.data.zoneCode;
        userDetail.addressCode = response.data.zoneCode;
      } catch (error) {
        this.loading = false;

        if(error.response) {
          if (typeof error.response.data == "string") {
            this.orderResponse = error.response.data;
          } else if (error.response.data.length > 0) {
            this.orderResponse = error.response.data[0];
          } else if (Object.keys(error.response.data).length === 0) {
            this.orderResponse = "Server error. Please try another time...";
          } else {
            this.orderResponse = error.response.data;
          }
        } else {
          this.orderResponse = "Server error. Please try again...";
        }
        return false;
      }

      return true;
    },
    async submitAddress(userDetail){
      // add new address
      const address = {
        distribution_node_code: this.addressCode,
        address_unit: this.unitNumber || "",
        address_street: `${this.fullAddress.street_number || ""} ${
            this.fullAddress.route || this.fullAddress.street_name
        }`.trim(),
        orderDetails: userDetail
      };
      console.log("address info", address);

      try {
        const response = await this.$http.post(
            `${process.env.VUE_APP_BACKEND_URL}order/add_address`,
            address
        );
        console.log("address response", response);

        if (response.data.fakePass) {
          this.$router.push({
            name: "complete",
            params: {
              orderNumber: response.data.orderNumber,
            },
          });

          return false;
        }

        this.addressId = response.data;
      } catch (error) {
        this.loading = false;

        if(error.response) {
          if (typeof error.response.data == "string") {
            this.orderResponse = error.response.data;
          } else if (error.response.data.length > 0) {
            this.orderResponse = error.response.data[0];
          } else if (Object.keys(error.response.data).length === 0) {
            this.orderResponse = "Server error. Please try another time...";
          } else {
            this.orderResponse = error.response.data;
          }
        } else {
          this.orderResponse = "Server error. Please try again...";
        }

        return false;
      }

      return true;
    },
    getCustomerInfo() {
      return {
        username: this.makeUsername(),
        titleId: this.customer.titleId,
        firstName: this.customer.firstName,
        lastName: this.customer.lastName,
        email: this.customer.email.trim(),
        daytimeContactNumber: this.customer.daytimeContactNumber,
        cellphone: this.phoneValidate,
        idNumber: this.customer.idNumber,
        companyName: this.customer.companyName,
        vatNumber: this.customer.vatNumber,
        accountId: this.customer.accountId
      };
    },
    async changeCustomerInfoInBackend() {
        console.log("DATA IN FRONTEND NOW ======>", this.customer);
        if (!this.billingCode || (this.authType[this.mesAuthAndAddMasterAccount] || this.authType[this.mesAuthAndAddSubAccount])) {
          const response = await axios.post(`${process.env.VUE_APP_BACKEND_URL}order/lookup_existing_customer`, {
            cellphoneNumber: this.phoneValidate,
            accountId: this.userAccount.value
          });
          if(!response.data.result && response.data.result !== undefined || !response.data) {
            console.log("DATA FROM BACKEND ======>", response.data);
            return false;
          }
          console.log("DATA TO BACKEND NOT REBUILT ======>", response.data);
          for (let key in response.data) {
            if(key === "titleId") {
              const userTitle = this.titleIds.find(item => item.label === response.data[key]);
              console.log("USER TITLE", userTitle.value);
              if (userTitle) {
                this.customer[key] = userTitle.value
              } else {
                this.customer[key] = 11;
              }
            } else {
              this.customer[key] = response.data[key];
            }
          }
          this.customer['accountId'] = this.userAccount.value;
        } else {
          this.customer['accountId'] = this.userAccount.value;
          this.customer['cellphone'] = this.phoneValidate;
        }
      console.log("DATA TO BACKEND AFTER REBUILD ======>", this.customer);
      return this.customer;
    },
    getProductInfo() {
      return {
        productIds: this.productIds,
        product_details: {
          code: this.product.code,
          name: this.product.name,
          provider_name: this.zone.provider_name,
          monthly_price: `R${this.product.monthly}`,
          once_off_fees:
            this.product.setup == "0.00"
              ? "FREE Activation"
              : `R${this.product.setup} INCL. VAT Once off setup fee`,
          install_type: this.installType,
        },
      };
    },
    getAddressInfo() {
      return {
        addressCode: this.addressCode,
        physical_city: this.fullAddress.administrative_area_level_2,
        physical_code: this.fullAddress.postal_code,
        physical_country: this.fullAddress.country,
        physical_line_1: `${this.fullAddress.street_number || ""} ${
          this.fullAddress.premise ||
          this.fullAddress.route ||
          this.fullAddress.street_name
        }`,
        physical_line_2: "",
        physical_suburb: this.fullAddress.political,
        physical_province: this.fullAddress.administrative_area_level_1,
        physical_unit_number: this.unitNumber,
        position: this.position,
        locality: this.fullAddress.locality,
      };
    },
    getUserInput() {
      const agentId = store.state.agentId;
      return {
        ...this.getCustomerInfo(),
        ...this.getAddressInfo(),
        ...this.getProductInfo(),
        ...agentId && {agentId},  // If agentId is defined add it to the user input
      };
    },
    async submitUpgradeDowngrade() {
      this.loading = true;
      console.log("productIds", this.productIds);
      console.log("product", this.product);

      let userInformation;
      try {
        userInformation  = !this.show.dataInput || this.show.dataInput && (this.authType[this.mesAuthAndAddMasterAccount] || this.authType[this.mesAuthAndAddSubAccount]) ? await this.changeCustomerInfoInBackend() : false;

        if (!this.show.dataInput && !userInformation) {
          this.clearingFields();
          this.loading = false;
          this.orderResponse = "User data not found, please try again or fill in the data yourself.";
          return;
        }
      } catch (error) {
        this.loading = false;
        if(error.response) {
          if (typeof error.response.data == "string") {
            this.orderResponse = error.response.data;
          } else if (error.response.data.length > 0) {
            this.orderResponse = error.response.data[0];
          } else if (Object.keys(error.response.data).length === 0) {
            this.orderResponse = "Server error. Please try another time...";
          } else {
            this.orderResponse = error.response.data;
          }
        } else {
          this.orderResponse = "Server error. Please try again...";
        }
        return;
      }

      let userInput = this.getUserInput();

      console.log("upgrade_downgrade userInput", userInput);
      try {
        const upgradeDowngradeUrl = `${process.env.VUE_APP_BACKEND_URL}order/upgrade_downgrade`;
        let response = await this.$http.post(upgradeDowngradeUrl, userInput);
        console.log("upgrade_downgrade response", response);

        this.$router.push({
          name: "upgradeRequestSent",
        });
      } catch (e) {
        console.log("Upgrade downgrade error", e);
        this.orderResponse = "This upgrade cannot be processed, please email " +
          "orders@lightspeed.co.za with your request";
      }
      this.loading = false;
    },
    async submitOrder() {
      this.loading = true;
      let userInformation;
      try {
        userInformation  = !this.show.dataInput ? await this.changeCustomerInfoInBackend() : false;

        if (!this.show.dataInput && !userInformation) {
          this.clearingFields();
          this.loading = false;
          this.orderResponse = "User data not found, please try again or fill in the data yourself.";
          return;
        }
      } catch (error) {
        this.loading = false;
        if(error.response) {
          if (typeof error.response.data == "string") {
            this.orderResponse = error.response.data;
          } else if (error.response.data.length > 0) {
            this.orderResponse = error.response.data[0];
          } else if (Object.keys(error.response.data).length === 0) {
            this.orderResponse = "Server error. Please try another time...";
          } else {
            this.orderResponse = error.response.data;
          }
        } else {
          this.orderResponse = "Server error. Please try again...";
        }
        return;
      }

      this.orderResponse = null;
      let userInput = this.getUserInput();

      console.log("TEST DATA userInput", userInput);


      // handle address / zone stuff
      this.addressId = this.findSimilarAddress();
      console.log("found addressId: ", this.addressId);
      console.log("found zone", this.addressCode);

      if (!this.addressId && !this.addressCode) {
        const res = await this.submitZone(userInput);

        if (!res) {
          return;
        }
      }

      if (!this.addressId) {
        const res = await this.submitAddress(userInput);

        if (!res) {
          return ;
        }
      }

      if (typeof this.addressId === "object") {
        userInput.addressId = this.addressId.addressId || this.addressId.id;
      } else {
        userInput.addressId = this.addressId;
      }
      if (this.zone.preOrder) {
        userInput.preOrder = true;
      }
      console.log("LOOK HERE::", userInput);

      /* eslint-disable */
      this.$http
        // .post(`${process.env.VUE_APP_BACKEND_URL}order/testpdf`, userInput)
        .post(`${process.env.VUE_APP_BACKEND_URL}order/create_customer`, userInput)
        .then((response) => {
          console.log("TEST DATA CREATE_CUSTOMER RESPONSE", response.data);
          this.loading = false;
          const newUrl = response.data.fakePass? "complete" : "inviteSent";
          this.$router.push({
            name: newUrl,
            params: {
              orderNumber: response.data.orderNumber,
            },
          });
        })
        .catch((error) => {
          this.loading = false;
          if(error.response) {
            if (typeof error.response.data == "string") {
              this.orderResponse = error.response.data;
            } else if (error.response.data.length > 0) {
              this.orderResponse = error.response.data[0];
            } else if (Object.keys(error.response.data).length === 0) {
              this.orderResponse = "Server error. Please try another time...";
            } else {
              this.orderResponse = error.response.data;
            }
          } else {
            this.orderResponse = "Server error. Please try again...";
          }
        });
      /* eslint-enable */
    },
    getAccountStatus(status) {
      if (status === "Active Account") {
        return this.accountStatusesInSelect["Active Account"];
      } else if (status === "Suspended Account") {
        return this.accountStatusesInSelect["Suspended Account"];
      } else {
        return this.accountStatusesInSelect["Inactive Account"];
      }
    },
    get: _.get,
  },
};
</script>

<style lang="scss">
@import "~bulma/sass/utilities/mixins";
@import "../styles/variables";
@import "../vue-select-corrected";

.custom-phone {
  margin-top: 1rem;
  height: 3rem;
  .detail-custom-phone-input {
        border-radius: 0;
        height: 50px;
        border: 1px solid transparent;
        background: transparent;
        box-shadow: -1px 1px 4px 1px rgba(80, 80, 80, 0.15);

        &::placeholder {
          opacity: 0;
          color: $secondary-colour;
          display: block;
        }

        & + .placeholder {
          visibility: hidden;
          margin-top: -2.275rem;
          width: 100%;
          font-weight: normal;
          text-align: left;
          margin-left: 1rem;
          line-height: 1.7;
          font-size: .7rem;
          color: $secondary-colour;
        }

        &:placeholder-shown + .placeholder {
          visibility: visible;
        }
      }
  .vue-tel-input.disabled {
    background: transparent;
  }
  .vti__dropdown.open, .vti__dropdown:hover {
    background-color: unset;
  }


      &.has-error .details-input {
        border-color: red;
        color: red;

        & + .placeholder {
          color: red;
        }
      }
}

.vti__dropdown-list {
  z-index: 999;
}
.vti__input {
  background: transparent;
  font-size: 1rem;
}
.vs--disabled .vs__dropdown-toggle {
  background-color: transparent!important;
}
.vs--disabled .vs__search {
  background-color: transparent!important;
}
.vs--disabled .vs__dropdown-toggle:hover{
  background-color: transparent!important;
  cursor: not-allowed;
}
.vs__dropdown-toggle {
  background-color: #ffffff;
  box-shadow: -1px 1px 4px 1px rgba(80,80,80,.15);

  &:hover {
    background-color: #ffffff;
  }
}

.vs__dropdown-option {
  //background-color: #f0f0f0;

  &:hover {
    background-color: $our_blue;
  }
}

.vs__dropdown-option--highlight {
  //background-color: initial;
  //opacity: 0;
}

.mb-5 {
  padding-bottom: 1rem;
}
@media screen and (min-width: 1024px) {
  .billing .product .title {
    color: #fff !important;
  }
}

.billing {
  padding: 3rem;
  justify-content: center;

  .product {
    align-self: stretch;
    font-size: 1.25rem;
    letter-spacing: 3px;
    text-align: left;
    margin-bottom: 2rem;

    @include from($desktop) {
      background-color: #01a5e8;
      color: #fff;
      padding: 3rem;
      font-size: 1.5rem;
      margin-bottom: 0;
      span {
        display: block;
      }
    }

    .product-name {
      font-weight: 900;
      text-transform: uppercase;
    }

    p {
      word-wrap: break-word;
      overflow-wrap: break-word;
    }
  }

  .details-customer {
    .input-group {
      .custom-select {
        margin-top: 1rem;
        height: 3rem;
          border-radius: 0;
          border: 1px solid transparent;
          background: transparent;
          padding: 1.5rem 1rem;
          box-shadow: -1px 1px 4px 1px rgba(80, 80, 80, 0.15);
      }
    }
  }

  .details {
    border-radius: 0;
    margin: 0 1rem;
    padding: 2rem 2rem 4rem;

    .input-group {
      margin-top: 1rem;
    }

    @include until($desktop) {
      border: none;
      box-shadow: none;
      padding: 0;
      margin: 0;
    }

    @include from($desktop) {
      max-width: 40vw;
    }

    .details-section {
      margin: 1rem 1rem 1rem 0;
      cursor: pointer;

      &:last-child {
        margin-right: 0;
      }

      .details-section-label {
        display: block;
        text-align: center;
        padding: 1rem;
        border: 2px solid $secondary-colour;
        text-transform: uppercase;

        &.active {
          color: #fff;
          background-color: $secondary-colour;
        }
      }
    }
  }

  .finalized {
    border-radius: 0;
    text-align: left;
    padding: 2rem;

    @include until($desktop) {
      border: none;
      box-shadow: none;
      padding: 0;
      margin: 2rem 0;
    }

    .finalized-address {
      margin-bottom: 1.5rem;

      .segment {
        display: inline;
      }

      @include from($desktop) {
        font-size: 2rem;
        line-height: 1.125;
        .segment {
          display: block;
        }
      }
    }

    .finalize-button {
      padding: 0.75rem 1.5rem;
      border-radius: 0;
      height: unset;
      font-weight: bold;
      font-size: 0.8rem;
      width: 100%;
    }

    .finalized-tax {
      font-size: 0.8rem;
      margin-bottom: 0.2rem;
    }

    .tandcs {
      margin-top: 0.5rem;
      margin-bottom: 1.5rem;
      span {
        margin-left: 0.5rem;
      }
    }
  }
  .buttons-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    text-align: center;
    margin-top: 25px;
    flex-wrap: nowrap;
    & button {
      margin: 5px;
      font-size: 0.8rem;
      padding: 20px;
      border-radius: 0;
      width: 100%;
    }
    &.via {
      & button {
        width: 100%;
      }
    }
  }
  .send {
    &__wrapper {
      //position: relative;
    }
    &__icon {
      color: #01a5e8;
      position: relative;
      top: -47px;
      right: -5px;
      font-size: 8pt;
      bottom: 5px;
      font-weight: bold;
    }
  }
  .mes {
    display: grid;
    text-align: left;
    padding-bottom: 15px;
    &__interval {
      color: gray;
      font-size: 8pt;
      margin-top: 15px;
      font-weight: normal;
      float: left;
    }
    &__billingCodePin {
      color: #01a5e8;
      font-size: 8pt;
      margin-top: 15px;
      float: left;
    }
  }
  .sub-account-addiction {
    padding-bottom: 20px;
    font-size: 14px;
    color: #01a5e8;
  }
  .create-contact-message {
    color: #01a5e8;
    text-align: center;
    margin-top: 15px;
    font-size: 14px;
  }
  .add-new-address-button {
    padding: 0.75rem 1.5rem;
    height: unset;
    font-weight: bold;
    font-size: 0.8rem;
    width: 69%;
    height: 48px;
  }
  .masked-block {
    text-align: left;
    margin-top: 10px;
    font-size: 10px;
    &__title {
      color: gray;
    }
  }
  @media screen and (max-width: 1460px) {
    .buttons-wrapper {
      flex-wrap: wrap;
      padding: 0.75rem 1.5rem
    }
  }
}
</style>
